import { useState, type FormEvent } from 'react';
import { login } from '../api/client';

interface LoginProps {
  onSuccess: () => void;
}

/**
 * The front door for admin.staynow.live.
 *
 * The password is never compared in the browser — it is posted to the server,
 * which checks it in constant time and returns a short-lived session token.
 * Nothing secret is bundled into this page.
 */
export default function Login({ onSuccess }: LoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!password || submitting) return;

    setSubmitting(true);
    setError(null);
    try {
      await login(password);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Connexion impossible');
      setPassword('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-logo">
          <div className="sidebar-logo-mark">S</div>
          <div>
            <div className="sidebar-logo-text">Staynow</div>
            <div className="login-subtitle">Console de modération</div>
          </div>
        </div>

        <label className="login-label" htmlFor="admin-password">
          Mot de passe
        </label>
        <input
          id="admin-password"
          className="login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          autoFocus
          disabled={submitting}
        />

        {error && <div className="login-error">{error}</div>}

        <button
          className="login-button"
          type="submit"
          disabled={submitting || !password}
        >
          {submitting ? 'Connexion…' : 'Se connecter'}
        </button>

        <p className="login-note">
          Accès réservé. Toutes les actions de modération sont journalisées.
        </p>
      </form>
    </div>
  );
}
